export default __webpack_public_path__ + "static/grafana-6067890cef04d5d29ef9d1109e0d23e1.png";